import { render } from "./PortUpdateVlaueTable.vue?vue&type=template&id=1b4462f9&scoped=true"
import script from "./PortUpdateVlaueTable.vue?vue&type=script&lang=js"
export * from "./PortUpdateVlaueTable.vue?vue&type=script&lang=js"

import "./PortUpdateVlaueTable.vue?vue&type=style&index=0&id=1b4462f9&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4462f9"]])

export default __exports__